import { useCallback, useRef, useState } from 'react';
import useVideoContext from './useVideoContext';
import { useTwilioAppState } from '../state/';

export default function useLocalVideoToggle() {
    const {
        room: { localParticipant },
        localTracks,
        getLocalVideoTrack,
        removeLocalVideoTrack,
        onError
    } = useVideoContext();
    const { _isMounted } = useTwilioAppState();
    const videoTrack = localTracks.find(track => track.name.includes('camera'));
    const [isPublishing, setIspublishing] = useState(false);
    const [isUnPublishing, setIsUnpublishing] = useState(false);
    const previousDeviceIdRef = useRef();

    const toggleVideoEnabled = useCallback(() => {
        if (!isPublishing && !isUnPublishing && _isMounted && _isMounted.current === true) {
            if (videoTrack) {
                setIsUnpublishing(true);
                previousDeviceIdRef.current = videoTrack.mediaStreamTrack.getSettings().deviceId;
                if (localParticipant) {
                    try {
                        const localTrackPublication = localParticipant.unpublishTrack(videoTrack);
                        // TODO: remove when SDK implements this event. See: https://issues.corp.twilio.com/browse/JSDK-2592
                        localParticipant.emit('trackUnpublished', localTrackPublication);
                        removeLocalVideoTrack();
                    } catch (err) {
                        console.log(err);
                    }
                }
                setIsUnpublishing(false);
            } else {
                if (_isMounted && _isMounted.current === true)
                    setIspublishing(true);
                getLocalVideoTrack({ deviceId: { exact: previousDeviceIdRef.current } })
                    .then(track => {
                        if (_isMounted && _isMounted.current === true)
                            localParticipant && localParticipant.publishTrack(track, { priority: 'low' });
                    })
                    .catch(onError)
                    .finally(() => { if (_isMounted && _isMounted.current === true) setIspublishing(false); });
            }
        }
    }, [videoTrack, localParticipant, getLocalVideoTrack, isPublishing, isUnPublishing, onError, removeLocalVideoTrack, _isMounted]);

    return [!!videoTrack, toggleVideoEnabled, _isMounted];
}
